import { render, staticRenderFns } from "./bloodSugar.vue?vue&type=template&id=7689f4ec&scoped=true"
import script from "./bloodSugar.vue?vue&type=script&lang=js"
export * from "./bloodSugar.vue?vue&type=script&lang=js"
import style0 from "./bloodSugar.vue?vue&type=style&index=0&id=7689f4ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7689f4ec",
  null
  
)

export default component.exports